import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as returnVoucherService from "../services/returnVoucherService";

export const useReturnVoucherQuery = () => {
  return useQuery({
    queryKey: ["returnVoucher"],
    queryFn: () => returnVoucherService.fetchReturnVouchers(),
  });
};

export const useReturnVoucherByIdQuery = (id) => {
  return useQuery({
    queryKey: ["returnVoucher", id],
    queryFn: () => returnVoucherService.fetchReturnVoucherById(id),
    enabled: !!id,
  });
};

export const useCreateReturnVoucher = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (returnVoucherData) =>
      returnVoucherService.createReturnVoucher(returnVoucherData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["returnVoucher"] });
    },
    onError: (error) => {
      console.error("Failed to create return voucher:", error);
    },
  });
};

export const useNoReturnVoucherPackages = () => {
  return useQuery({
    queryKey: ["noReturnVoucherPackages"],
    queryFn: () => returnVoucherService.getAllPackagesNoReturnVoucher(),
  });
};

export const useGenerateReturnVoucherPDF = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (returnVoucherId) =>
      returnVoucherService.generateReturnVoucherPDF(returnVoucherId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["returnVoucher"] });
    },
    onError: (error) => {
      console.error("Failed to generate return voucher PDF:", error);
    },
  });
};
